import { a, div, h2, input, label, p, span } from '@srfnstack/fntags'
import { CreditButton } from '../../components/CreditButton.js'
import { NumberSpinner } from '../../components/NumberSpinner.js'
import { CsvIngest } from './CsvIngest.js'
import { ModelSelector, ALL_IMAGE_PROVIDERS } from '../../components/ModelSelector.js'

export const EtsyIngest = ({
  extensionInstalled, batchSize, ingestStatus, singleUrl, scrapeMultipliers,
  csvBatchSize, csvUrlCount,
  handleUrlIngest, handleFileSelect, handleUpload, imageModel
}) =>
  div({ class: 'card bg-base-200 shadow-xl border border-base-300' },
    div({ class: 'card-body p-6' },
      div({ class: 'flex justify-between items-start mb-4' },
        h2({ class: 'card-title' }, 'Etsy Product Inspiration'),
        extensionInstalled.bindAs(installed => installed
          ? div({ class: 'badge badge-success gap-2 py-3' },
            span({ class: 'material-symbols-rounded text-sm' }, 'check_circle'),
            span({ class: 'text-[10px] font-bold uppercase' }, 'Extension Active')
          )
          : a({
            href: '/downloads/etherbuildr-chrome-extension.zip',
            download: 'etherbuildr-chrome-extension.zip',
            class: 'btn btn-outline btn-warning btn-xs gap-1'
          },
          span({ class: 'material-symbols-rounded text-xs' }, 'download'),
          'Download Extension'
          )
        )
      ),
      ingestStatus.bindAs(status => {
        if (status.message) {
          return div({ class: `alert alert-${status.type} mb-4` },
            span(status.message)
          )
        }
        return span()
      }),

      div({ class: 'space-y-6' },
        div({ class: 'flex flex-col gap-3' },
          label({ class: 'label p-0' }, span({ class: 'label-text font-bold text-xs uppercase opacity-50' }, 'Scrape One URL')),
          div({ class: 'flex gap-2 items-end' },
            div({ class: 'join flex-grow' },
              input({
                class: 'input input-bordered join-item flex-grow',
                placeholder: 'https://www.etsy.com/listing/...',
                value: singleUrl.bindAttr(),
                oninput: (e) => singleUrl(e.target.value)
              }),
              CreditButton({
                actionCode: 'ETSY_ANALYSIS',
                label: 'Scrape',
                class: 'btn btn-primary join-item',
                onclick: handleUrlIngest,
                disabled: ingestStatus.bindAttr(s => s && s.loading),
                multipliers: scrapeMultipliers
              })
            ),
            div({ class: 'form-control' },
              label({ class: 'label p-0 mb-1' }, span({ class: 'label-text text-[10px] font-bold uppercase opacity-40' }, 'Images')),
              NumberSpinner({ state: batchSize, min: 1, max: 100 })
            ),
            div({ class: 'form-control' },
              label({ class: 'label p-0 mb-1' }, span({ class: 'label-text text-[10px] font-bold uppercase opacity-40' }, 'Model')),
              ModelSelector({ model: imageModel, providers: ALL_IMAGE_PROVIDERS })
            )
          ),
          p({ class: 'text-[10px] opacity-60' }, 'Paste a single Etsy product URL to scrape it immediately.')
        ),

        div({ class: 'divider text-[10px] opacity-30 uppercase font-bold' }, 'OR'),

        CsvIngest({ csvBatchSize, csvUrlCount, ingestStatus, handleFileSelect, handleUpload })
      )
    )
  )
